import { T } from '../theme';
import type { OptimizationVM } from '../../formatters/deckContent';

interface Props {
  vm: OptimizationVM;
}

/** Fallback framing — a clean value tile + the optimization's blurb. */
export function GenericPanel({ vm }: Props) {
  return (
    <div>
      <div
        style={{
          background: T.growthSoft,
          borderRadius: 12,
          padding: '28px 24px',
          textAlign: 'center',
          marginBottom: 18,
        }}
      >
        <div style={{ fontSize: 40, fontWeight: 700, color: T.growth, lineHeight: 1 }}>{vm.valueAddedLabel}</div>
        <div style={{ fontSize: 13, color: T.growth, fontWeight: 600, marginTop: 8 }}>added to your plan</div>
      </div>
      <p style={{ fontSize: 14, color: T.ink, lineHeight: 1.6, margin: 0 }}>{vm.blurb}</p>
    </div>
  );
}
